import { TTooltipPosition } from './types';

type TGetTooltipPosition = {
   child: HTMLElement,
   tooltip: HTMLDivElement,
   position: TTooltipPosition,
   gap: number,
   arrowIndent: number,
};

type TTooltipVector = {
   left: number,
   top: number,
};

export const getTooltipPosition = ({
   child,
   tooltip,
   position,
   gap,
   arrowIndent,
}: TGetTooltipPosition): TTooltipVector => {
   const {
      top: childTop,
      left: childLeft,
      height: childHeight,
      width: childWidth,
   } = child.getBoundingClientRect();

   const { width: tooltipWidth, height: tooltipHeight } = tooltip.getBoundingClientRect();

   const scrollY = (window.scrollY !== undefined) ? window.scrollY : window.pageYOffset;
   const scrollX = (window.scrollX !== undefined) ? window.scrollX : window.pageXOffset;

   switch (position) {
      case 'top-center': {
         return {
             left: childLeft + childWidth / 2 - tooltipWidth / 2 + scrollX,
             top: childTop - gap - tooltipHeight + scrollY,
         };
      }
      case 'top-left': {
         return {
             left: childLeft - arrowIndent + scrollX,
             top: childTop - gap - tooltipHeight + scrollY,
         };
      }
      case 'top-right': {
         return {
             left: childLeft + childWidth - tooltipWidth + arrowIndent + scrollX,
             top: childTop - gap - tooltipHeight + scrollY,
         };
      }
      case 'left': {
         return {
             left: childLeft - gap - tooltipWidth + scrollX,
             top: childTop + childHeight / 2 - tooltipHeight / 2 + scrollY,
         };
      }
      case 'right': {
         return {
             left: childLeft + childWidth + gap + scrollX,
             top: childTop + childHeight / 2 - tooltipHeight / 2 + scrollY,
         };
      }
      case 'bottom-left': {
         return {
             left: childLeft - arrowIndent + scrollX,
             top: childTop + childHeight + gap + scrollY,
         };
      }
      case 'bottom-right': {
         return {
            left: childLeft + childWidth - tooltipWidth + arrowIndent + scrollX,
            top: childTop + childHeight + gap + scrollY,
         };
      }
      case 'bottom-center':
      default:
         return {
             left: childLeft + childWidth / 2 - tooltipWidth / 2 + scrollX,
             top: childTop + childHeight + gap + scrollY,
         };
   }
};

type TCreateCornerMap<T> = {
   position: TTooltipPosition,
   onCornerLeft: T,
   onCornerRight: T,
   onDefault: T,
}

export const createCornerMap = <T>({
   position,
   onCornerLeft,
   onCornerRight,
   onDefault,
}: TCreateCornerMap<T>) => {
   return ['top-left', 'bottom-left'].includes(position)
       ? onCornerLeft
       : ['top-right', 'bottom-right'].includes(position)
       ? onCornerRight
       : onDefault;
};
